module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "p-toolbar p-component mb-4"
  }, [_c('warehouseDialog', {
    ref: "openDialog"
  })], 1), _vm._v(" "), _c('warehouseList', {
    on: {
      "edit-warehouse": _vm.editWarehouse,
      "delete-message": _vm.deleteWarehouse
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e89a59d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/warehouse/Warehouse.vue
// module id = 2430
// module chunks = 0